import './ContactHero.css';

export default function ContactHero() {
	return (
		<section className='contact-hero'>
			<div className='contact-hero__shape contact-hero__shape--dots' />
			<div className='contact-hero__shape contact-hero__shape--lines' />
			<div className='contact-hero__inner'>
				<h1 className='contact-hero__title'>Contact</h1>

				<div className='contact-hero__breadcrumb'>
					<a href='/'>Home</a>
					<span>/</span>
					<span>Contact </span>
				</div>
			</div>
		</section>
	);
}
